import React, { useState } from "react";
import './styles.css'
import { signIn } from "../api/login";
import useToken from "../hooks/useToken";
import { Link } from "react-router-dom";
import Alert from "../components/alert";

const Login = () => {
	let [username, setUsername] = useState('');
	let [pass, setPass] = useState('');
	let [errorCode, setErrorCode] = useState<number>();
	let [errorMessage, setErrorMessage] = useState('');
	const { logIn } = useToken();

	const login = async (e: any) => {
		e.preventDefault();
		try {
			let result = await signIn(username, pass, 'new')
			if (result.token) {
				if (result.role === "ScanningAgent") {
					setErrorCode(1);
					setErrorMessage('Scanning Agents cannot login to Website');
				} else {
					logIn({
						userName: result.username,
						accessToken: result.token,
						role: result.role,
						dealerId: result.dealerId,
						dealershipName: result.dealershipName,
						dealerCode: result.dealercode,
						email: result.email
					})

					// if version is null, fallback to v1
					if (result.returnUrl === null) {
						result.returnUrl = "v1";
					}
					
					// local development, no bucket versioning
					if (process.env.REACT_APP_MAIN_URL === "http://localhost:3001") {
						window.open(`${process.env.REACT_APP_MAIN_URL}`, '_self');

					} else {
						// else navigate to appropriate bucket
						window.open(`${process.env.REACT_APP_MAIN_URL}/${result.returnUrl}/`, '_self');
					}
				}
			} else {
				setErrorCode(1);
				setErrorMessage(result.message)
			}
		} catch (error: any | undefined) {
			if (error) {
				setErrorCode(1);
				setErrorMessage("Something went wrong, Please try again later");
			}
		}
	}

	const isFormValid = username.trim() !== '' && pass.trim() !== '';

	const handleClose = () => {
		setErrorCode(undefined);
		setErrorMessage('');
	}

	return (
		<div className="App flex justify-center items-center">
			<div className="glass1 p-5 w-full max-w-md">
				<h1 className="mb-2 text-md sm:text-xl md:text-2xl lg:text-2xl xl:text-2xl font-medium leading-none tracking-tight text-gray-900 dark:text-white text-center">
					Please sign in to your account
				</h1>

				<form className="p-3" onKeyDown={(e) => {
					if (e.key === 'Enter') {
						login(e);
					}
				}}>
					<label htmlFor="website-admin" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">
						User Name
					</label>
					<div className="flex">
						<span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 rounded-s-md dark:bg-transparent dark:text-gray-400 dark:border-gray-600">
							<svg
								className="w-6 h-6 text-gray-500 dark:text-white"
								aria-hidden="true"
								xmlns="http://www.w3.org/2000/svg"
								fill="currentColor"
								viewBox="0 0 20 20"
							>
								<path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
							</svg>
						</span>
						<input
							type="text"
							id="website-admin"
							className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-[#74ac9b] focus:border-[#74ac9b] block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  dark:bg-transparent dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-[#74ac9b] dark:focus:border-[#74ac9b]"
							placeholder="John Doe"
							onChange={(e) => setUsername(e.target.value)}
						/>
					</div>

					{/* Password container */}
					<label htmlFor="website-password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left mt-3">
						Password
					</label>
					<div className="flex">
						<span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 rounded-s-md dark:bg-transparent dark:text-gray-400 dark:border-gray-600">
							<svg
								className="w-6 h-6 text-gray-800 dark:text-white"
								aria-hidden="true"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 16 20"
							>
								<path
									stroke="currentColor"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="2"
									d="M11.5 8V4.5a3.5 3.5 0 1 0-7 0V8M8 12v3M2 8h12a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z"
								/>
							</svg>
						</span>
						<input
							type="password"
							id="website-password"
							className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-[#74ac9b] focus:border-[#74ac9b] block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5  dark:bg-transparent dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-[#74ac9b] dark:focus:border-[#74ac9b]"
							placeholder="&Ay8SdpBdK$YpH"
							onChange={(e) => setPass(e.target.value)}
						/>
					</div>

					<div className="loginBtnContainer mt-2 w-100 text-lg">
						<button type="button" className="loginButton" disabled={!isFormValid} id="submit-btn" onClick={(e) => {
							login(e)
						}}>
							Log In
						</button>
					</div>
				</form>

				<div className='bottomContainer mt-3'>
					<div className="passwordContainer flex justify-center items-center">
						<Link to="/forgotPassword" className='drop-shadow-lg text-center items-center text-graphite font-montega'>
							Forgot Password?
						</Link>
					</div>
					<div className='policyContainer'>
						<div className="text-center" style={{ fontFamily: 'Arial' }}>
							By signing in, you agree to the <a href="https://www.scansolutions.com/vehicle-wizard-terms-of-service">Terms of Service</a> and <a href="https://www.scansolutions.com/privacy-policy">Privacy Policy</a>.
						</div>
					</div>
				</div>
			</div>
			{errorCode === 1 || errorCode === 0 ? (
				<div className="absolute top-0 right-0">
					<Alert code={errorCode} message={errorMessage} onClose={handleClose} />
				</div>
			) : null}
		</div>
	);
}

export default Login